import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { UserItem } from './UserItem';

const UserList = () => {
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [error, setError] = useState(null);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/manager/usuarios`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error('Erro ao buscar os usuários.');
            }

            const data = await response.json();
            setUsers(data.usuarios);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    if (error) {
        return <div className="text-2xl text-center text-red-600 font-bold my-10">{error}</div>;
    }

    return (
        <div
            className={`overflow-x-auto no-scrollbar relative mb-6 rounded-sm border border-stroke bg-white px-5 ${loading ? 'py-10' : 'py-5'} shadow-md`}
        >
            {loading && (
                <div className="absolute z-[100] inset-0 bg-white mx-auto py-10 flex justify-center">
                    <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
                </div>
            )}

            <div className="flex items-center justify-between gap-10 min-w-[26rem] mb-6">
                <h4 className="text-xl font-bold text-black">Administradores</h4>

                <Link
                    to="/manager/usuarios/adicionar"
                    className="flex items-center justify-center bg-primary text-sm sm:text-base text-white ml-auto px-4 h-9 rounded transition-all hover:bg-opacity-80"
                >
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    Adicionar usuário
                </Link>
            </div>

            <table className="w-full min-w-[26rem] table-auto border-collapse">
                <thead>
                    <tr>
                        <th className="p-2 pl-0 2xl:pl-4 text-left text-sm font-medium uppercase">Nome</th>
                        <th className="p-2 2xl:p-4 text-sm font-medium uppercase">E-mail</th>
                        <th className="p-2 2xl:p-4 text-sm font-medium uppercase">Criado</th>
                        <th className="p-2 2xl:p-4 text-sm font-medium uppercase"></th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => (
                        <UserItem refetch={fetchUsers} key={index} user={user} isSelected={false} isLast={index === users.length - 1} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UserList;
